var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close modal-back",on:{"click":_vm.onClickBack}},[_c('a-icon',{attrs:{"icon":"ArrowLeft"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }